function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $helpers, JSON, Object, alreadyInvitedError, attemptingNonceValidation, defaultFormValues, isInvited) {
    var h = require("panel").h;
    var jade_mixins = {},
      $mixins = jade_mixins;
    jade_mixins['auth-banners'] = function({
      success,
      info,
      error
    }) {
      var block = (this && this.block),
        attributes = (this && this.attributes) || {};

      return (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat((success) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-auth-banner-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-banner", {
              "attrs": __vjadeStringifyAttrsIfObj({
                id: `success-banner`,
                theme: `success`,
                size: `small`,
                type: `embedded`,
                'body-text': success,
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat((info) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-auth-banner-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-banner", {
              "attrs": __vjadeStringifyAttrsIfObj({
                id: `info-banner`,
                theme: `info`,
                size: `medium`,
                type: `embedded`,
                'body-text': info,
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);
        __jade_nodes = __jade_nodes.concat((error) ? ((function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat(h("div", {
            "class": {
              'mp-auth-banner-container': true
            },
          }, (function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("mp-banner", {
              "attrs": __vjadeStringifyAttrsIfObj({
                id: `error-banner`,
                theme: `warn`,
                size: `medium`,
                type: `embedded`,
                'body-text': error,
              }),
            }));;
            return __jade_nodes
          }).call(this).filter(Boolean)));;
          return __jade_nodes
        }).call(this)) : undefined);;
        return __jade_nodes
      }).call(this);
    };

    var __vjadeStringifyAttrsIfObj = function(attrs) {
      if (typeof attrs !== 'object') return attrs;
      const copy = {};
      for (const [k, v] of Object.entries(attrs)) {
        copy[k] = typeof attrs[k] === 'object' ? JSON.stringify(v) : v;
      }
      return copy;
    }
    const {
      COMPANY_SIZE_OPTIONS,
      DEPARTMENT_OPTIONS,
      MAU_SIZE_OPTIONS,
      Step
    } = require('../constants');;
    return {
      value: (h("auth-container", (function() {
        var __jade_nodes = [];
        __jade_nodes = __jade_nodes.concat(h("div", {
          "attrs": __vjadeStringifyAttrsIfObj({
            slot: 'auth-form-slot',
          }),
          "class": {
            'auth-form': true
          },
        }, (function() {
          var __jade_nodes = [];
          __jade_nodes = __jade_nodes.concat((attemptingNonceValidation) ? ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(h("div", {
              "class": {
                'spinner-wrapper': true
              },
            }, (function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("mp-spinner", {
                "attrs": __vjadeStringifyAttrsIfObj({
                  size: `large`
                }),
              }));;
              return __jade_nodes
            }).call(this).filter(Boolean)));;
            return __jade_nodes
          }).call(this)) : ((function() {
            var __jade_nodes = [];
            __jade_nodes = __jade_nodes.concat(jade_mixins['auth-banners'].call(this, {
              error: $attr(`already-invited-error`) || alreadyInvitedError
            }));
            __jade_nodes = __jade_nodes.concat((isInvited) ? ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("auth-invitation-form", {
                "attrs": __vjadeStringifyAttrsIfObj($helpers.getInvitationFormAttributes()),
                "props": {
                  defaultFormValues,
                },
                "on": {
                  alreadyInvitedError: (ev) => $helpers.handleAlreadyInvitedError(ev),
                  signUpSuccess: $helpers.handleSignUpSuccess
                },
              }));;
              return __jade_nodes
            }).call(this)) : ((function() {
              var __jade_nodes = [];
              __jade_nodes = __jade_nodes.concat(h("auth-signup-form", {
                "attrs": __vjadeStringifyAttrsIfObj($helpers.getSignupFormAttributes()),
                "props": {
                  defaultFormValues,
                },
                "on": {
                  alreadyInvitedError: (ev) => $helpers.handleAlreadyInvitedError(ev),
                  signUpSuccess: $helpers.handleSignUpSuccess
                },
              }));;
              return __jade_nodes
            }).call(this)));;
            return __jade_nodes
          }).call(this)));;
          return __jade_nodes
        }).call(this).filter(Boolean)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined, "Object" in locals ? locals.Object : typeof Object !== "undefined" ? Object : undefined, "alreadyInvitedError" in locals ? locals.alreadyInvitedError : typeof alreadyInvitedError !== "undefined" ? alreadyInvitedError : undefined, "attemptingNonceValidation" in locals ? locals.attemptingNonceValidation : typeof attemptingNonceValidation !== "undefined" ? attemptingNonceValidation : undefined, "defaultFormValues" in locals ? locals.defaultFormValues : typeof defaultFormValues !== "undefined" ? defaultFormValues : undefined, "isInvited" in locals ? locals.isInvited : typeof isInvited !== "undefined" ? isInvited : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;